import cn from 'classnames';
import { FC, MouseEventHandler, ReactNode } from 'react';

import { type TimelinePreview } from './Timeline.types';
import styles from './TimelineCard.module.scss';
import { TimelinePreviewImage } from './TimelinePreviewImage';

type TimelineCardProps = {
  title: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
  dataComponent?: string;
  isClickable?: boolean;
  isHidden?: boolean;
  isRemoving?: boolean;
  meta?: ReactNode;
  preview?: TimelinePreview;
  previewFallback?: ReactNode;
  testID?: string;
  time?: ReactNode;
  onAuxClick?: MouseEventHandler<HTMLDivElement>;
  onClick?: MouseEventHandler<HTMLDivElement>;
};

export const TimelineCard: FC<TimelineCardProps> = (props) => {
  const {
    title,
    actions,
    children,
    className,
    dataComponent,
    isClickable = Boolean(props.onClick),
    isHidden,
    isRemoving,
    meta,
    preview,
    previewFallback,
    testID,
    time,
    onAuxClick,
    onClick,
  } = props;

  return (
    <div
      data-component={dataComponent}
      data-testid={testID}
      className={cn(
        styles.container,
        !isClickable && styles.notClickable,
        isRemoving && styles.removing,
        isHidden && styles.hidden,
        className,
      )}
      onClick={onClick}
      onAuxClick={onAuxClick}
    >
      <div className={styles.header}>
        <div className={styles.heading}>
          {time !== undefined && (
            <span className={cn('p2', styles.time)}>{time}</span>
          )}

          <h4 className={cn('h5', styles.title)}>{title}</h4>

          {meta && <span className={cn('p3', styles.meta)}>{meta}</span>}
        </div>

        {actions && <div className={styles.actions}>{actions}</div>}
      </div>

      {preview ? (
        <TimelinePreviewImage {...preview} className={styles.preview} />
      ) : (
        previewFallback && (
          <div className={cn(styles.preview, styles.previewPlaceholder)}>
            {previewFallback}
          </div>
        )
      )}

      {children}
    </div>
  );
};
